import React, { Component } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import CacheRoute, { CacheSwitch } from 'react-router-cache-route'

import routeList from '../../config/routeMap'


export default class Layout extends Component {
    render() {
        return (
            <div className="app-container">
                <CacheSwitch>
                    {
                        routeList.map(route => {
                            const { cacheFlag, path, component } = route
                            const routeNode = (cacheFlag
                                ?
                                <CacheRoute
                                    key={path}
                                    path={path}
                                    component={component} />
                                :
                                <Route
                                    component={component}
                                    key={path}
                                    path={path}
                                />)
                            return routeNode
                        })
                    }
                    <Redirect to="/home" />
                </CacheSwitch>
            </div>
        )
    }
}
